<template>
  <Modal v-model="show"  @on-ok="update" :loading="loading" @on-cancel="cancel">
    <div slot="header" class="modal-header">修改供应商</div>
    <Form :model="formData" :label-width="100" :rules="formRules" ref="formData">
      <FormItem label="供应商编号" prop="code">
        <span class="item-width">{{formData.code}}</span>
      </FormItem>
      <FormItem label="供应商名称" prop="supplierName">
        <Input v-model="formData.supplierName" class="item-width"></Input>
      </FormItem>
      <FormItem label="品牌" prop="brand">
        <Input v-model="formData.brand" class="item-width"></Input>
      </FormItem>
      <FormItem label="供应类目" prop="categoryName">
        <Select v-model="formData.categoryName" multiple :label-in-value="true" class="item-width">
          <Option v-for="item in categoryList" :value="item.text" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="负责人" prop="manager">
        <Input v-model="formData.manager" class="item-width"></Input>
      </FormItem>
      <FormItem label="联系方式" prop="contactPhone">
        <Input v-model="formData.contactPhone" class="item-width"></Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>
  import {updateSupplier} from "api/supplier";
  import {deepClone} from "../../../../utils/format";

  export default {
    name: "UpdateSuppliersModal",
    props: {
      n: {
        type: Number,
        default: 0
      },
      categoryList: {
        type: Array,
        default: []
      },
      suppliersData: {
        type: Object,
        default: null
      }
    },
    watch: {
      n() {
        this.show = true
      }
    },
    data() {
      const validatecontactPhone = (rule, value, callback) => {
        let pattern = /^1(\d+){10}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的联系方式'));
        }
        callback();
      }
      return {
        show: false,
        loading: true,
        formRules: {
          supplierName: [
            {required: true, message: '请输入供应商名称', trigger: 'blur', type: 'string'}
          ],
          brand: [
            {required: true, message: '请输入品牌名称', trigger: 'blur', type: 'string'}
          ],
          categoryName: [
            {required: true, type: 'array', min: 1, message: '请选择类目', trigger: 'change'}
          ],
          manager: [
            {required: true, message: '请输入负责人', trigger: 'blur', type: 'string'}
          ],
          contactPhone: [
            {required: true, validator: validatecontactPhone, trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      formData: function () {
        if (this.suppliersData == null) {
          return {
            supplierName: '',
            brand: '',
            categoryName: [],
            manager: '',
            contactPhone: '',
            fid: '',
            code: ''
          }
        }
        return deepClone(this.suppliersData)
      },
    },
    methods: {
      cancel(){
        this.$refs['formData'].resetFields()
      },
      formValidate() {
        var ret = false
        this.$refs['formData'].validate(bool => {
          ret = bool
        })
        return ret
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      update() {

        this.$refs['formData'].validate(bool => {
          if(bool){
            let commitData = deepClone(this.formData)
            commitData.categoryName = commitData.categoryName.join(',')
            updateSupplier(commitData).then(() => {
              this.$Message.success('修改成功');
              this.show = false
              this.$emit('refresh')
            }).catch(error => {
              this.show = true
              this.loading = true
              this.$Message.error('修改失败');
            })
          }
          else {
            this.changeLoading()
          }
        })

      },
    }
  }
</script>

<style scoped>
  .item-width {
    width: 200px;
  }

  .area-width {
    width: 324px;
  }

</style>
